export default __webpack_public_path__ + "static/connectera-7f6caed412e3556f5243d936f6b1ad07.svg";